import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconCirclePlus({
  extColor,
  isAutoscallable = true,
  sizeKey = '18x18',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 18 18"
      fill={fill}
    >
      <rect x="1.5" y="1.5" width="15" height="15" rx="7.5" />
      <path
        d="M8.73757 4.53003C8.52622 4.60929 8.37299 4.74843 8.2726 4.95273L8.21624 5.06897L8.21096 6.64001L8.20744 8.21281L6.63464 8.21633L5.0636 8.22161L4.94031 8.2815C4.77828 8.36075 4.63914 8.49989 4.55988 8.66193C4.50176 8.78169 4.5 8.7905 4.5 9.00537C4.5 9.22024 4.50176 9.22905 4.55988 9.34882C4.63914 9.51085 4.77828 9.64999 4.94031 9.72925L5.0636 9.78913L6.63464 9.79441L8.20744 9.79794L8.21096 11.3707L8.21624 12.9418L8.27613 13.0651C8.35538 13.2271 8.49452 13.3662 8.65656 13.4455C8.77632 13.5036 8.78513 13.5054 9 13.5054C9.21487 13.5054 9.22368 13.5036 9.34344 13.4455C9.50548 13.3662 9.64462 13.2271 9.72387 13.0651L9.78376 12.9418L9.78904 11.3707L9.79256 9.79794L11.3654 9.79441L12.9364 9.78913L13.0597 9.72925C13.2217 9.64999 13.3609 9.51085 13.4401 9.34882C13.4982 9.22905 13.5 9.22024 13.5 9.00537C13.5 8.7905 13.4982 8.78169 13.4401 8.66193C13.3609 8.49989 13.2217 8.36075 13.0597 8.2815L12.9364 8.22161L11.3654 8.21633L9.79256 8.21281L9.78904 6.64001L9.78376 5.06897L9.72387 4.94569C9.64462 4.78365 9.50548 4.64451 9.34344 4.56702C9.22896 4.51066 9.20431 4.50537 9.02642 4.50185C8.86791 4.49657 8.81507 4.50185 8.73757 4.53003Z"
        fill={theme.palette.background.default}
      />
    </svg>
  );
}
